import slice from './dictionarySlice';

export * from './types';
export const {
  setDictionaryListAction,
  setDictionarySortAction,
  updateDictionaryItemAction,
  deleteDictionaryItemAction,
  toggleAllDictionarySelectionsAction,
} = slice.actions;

export default slice.reducer;
